import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appMaxNumber]'
})
export class MaxNumberDirective {

  qtdMaximaCaracteres = 0;
  caracteresPermitidos = '0123456789';

  constructor(private readonly element: ElementRef) {
    if (element && element.nativeElement.size) {
      this.qtdMaximaCaracteres = element.nativeElement.size;
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const elemento = event.target as HTMLTextAreaElement;
    const codigo = event.code;
    let deveExecutar = false;

    if (this.isCodigoControle(codigo)) {
      deveExecutar = true;
    } else {
      if (this.isCaractereValido(event.key) && this.isTamanhoValido(elemento)) {
        deveExecutar = true;
      }
    }

    if (!deveExecutar) {
      event.preventDefault();
    }
  }

  private isTamanhoValido(elemento) {
    let resultado = this.possuiTextoSelecionado(elemento);
    if (!resultado) {
      resultado = elemento.value.length < this.qtdMaximaCaracteres;
    }
    return resultado;
  }

  private possuiTextoSelecionado(elemento: HTMLTextAreaElement) {
    const inicioSelecao = elemento.selectionStart;
    const fimSelecao = elemento.selectionEnd;

    return (fimSelecao - inicioSelecao) > 0;
  }

  private isCodigoControle(codigo) {
    let resultado = false;
    switch (codigo) {
      case 'ArrowLeft':
      case 'ArrowRight':
      case 'ArrowTop':
      case 'ArrowDown':
      case 'Backspace':
      case 'Home':
      case 'End':
      case 'ShiftLeft':
      case 'ControlLeft':
      case 'ShiftRight':
      case 'ControlRight':
        resultado = true;
        break;
      default:
        break;
    }
    return resultado;
  }

  private isCaractereValido(caractere) {
    return this.caracteresPermitidos.indexOf(caractere) !== -1;
  }

}
